import { defineMessages } from 'react-intl';

export default defineMessages({
    insuranceType: {
        id: 'ml.quoteandbind.common.policySummary.Insurance type:',
        defaultMessage: 'Insurance type: '
    },
    policySummary: {
        id: 'ml.quoteandbind.common.policySummary.Policy Summary',
        defaultMessage: 'Policy Summary'
    },
    auto: {
        id: 'ml.quoteandbind.common.policySummary.Auto',
        defaultMessage: 'Auto'
    },
    effectiveDate: {
        id: 'ml.quoteandbind.common.policySummary.Effective Date:',
        defaultMessage: 'Effective Date: '
    },
    expirationDate: {
        id: 'ml.quoteandbind.common.policySummary.Expiration Date:',
        defaultMessage: 'Expiration Date: '
    },
    insured: {
        id: 'ml.quoteandbind.common.policySummary.Insured',
        defaultMessage: 'Insured'
    },
    coinsured: {
        id: 'ml.quoteandbind.common.policySummary.Co-Insured',
        defaultMessage: 'Co-Insured'
    },
    umbrella: {
        id: 'ml.quoteandbind.common.policySummary.Umbrella',
        defaultMessage: 'Umbrella'
    },
    policyLimit: {
        id: 'ml.quoteandbind.common.policySummary.Policy Limit:',
        defaultMessage: 'Policy Limit:'
    },
    selfInsuredRetention: {
        id: 'ml.quoteandbind.common.policySummary.Self Insured Retention:',
        defaultMessage: 'Self Insured Retention:'
    }
});
